import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sigecom-tabs',
  template: `
    <div class="flex gap-2 items-end">
      <div *ngFor="let tab of tabs"
          (click)="selectTab(tab)"
          class="overflow-hidden rounded-t-lg">
        <div
          class="px-4 py-3 cursor-pointer text-sm font-semibold transition-all rounded-t-lg whitespace-nowrap"
          [ngClass]="getTabClasses(tab)">
          {{ tab }}
        </div>
    </div>
  </div>
  `,
})
export class TabsComponent {

  @Input() tabs: string[] = [];
  @Input() selectedTab: string = '';
  @Output() selectedTabChange = new EventEmitter<string>();
  @Input() wrapperClass = '';
  @Input() activeTabBorderClass = '';
  @Input() selectedTabShadowClass = '';

  selectTab(tab: string) {
    this.selectedTab = tab;
    this.selectedTabChange.emit(tab);
  }

  getTabClasses(tab: string): any {
    const isSelected = tab === this.selectedTab;

    return {
      [this.wrapperClass]: true,
      [this.activeTabBorderClass]: isSelected,
      [this.selectedTabShadowClass]: isSelected,
      'text-blue-900 bg-white h-[48px]': isSelected,
      'text-gray-500 bg-gray-100 border border-transparent h-[40px] hover:bg-white hover:border-gray-300 hover:h-[48px] transition-all duration-200': !isSelected,
    };
  }
}
